const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHHouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    width: 500,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--theme-secondary)"
    },
    d: "M 93.235 209.272 C 141.807 225.341 174.477 349.054 165.187 493.38 L 309.948 494.665 C 314.123 454.99 319.696 305.33 393.278 167.418 L 93.235 209.272 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "var(--theme-primary)"
    },
    points: "16.571 227.412 462.422 163.169 270.117 7.224"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "var(--theme-secondary)"
    },
    points: "313.648 445.821 484.85 412.906 484.422 430.433 313.221 449.027"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "var(--theme-primary)"
    },
    points: "454.337 493.906 449.777 403.913 474.371 397.387 466.382 493.863"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "var(--theme-primary)"
    },
    points: "426.57 493.882 431.532 408.451 411.474 413.905 416.795 493.892"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "var(--theme-primary)"
    },
    points: "399.251 416.95 383.965 421.01 388.832 493.824 395.696 493.913"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "var(--theme-primary)"
    },
    points: "373.049 423.91 361.626 426.913 366.738 493.877 370.117 493.836"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "var(--theme-primary)"
    },
    points: "351.134 429.643 342.889 431.821 345.317 493.866 348.116 493.804"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "var(--theme-primary)"
    },
    points: "332.217 434.627 326.452 436.197 328.329 493.842 329.741 493.87"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--theme-secondary)"
    },
    d: "M 158.944 493.045 L 157.687 468.808 C 155.407 450.881 131.486 448.503 133.157 470.352 L 138.483 493.036 L 158.944 493.045 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--theme-secondary)"
    },
    d: "M 131.008 436.631 L 128.749 472.811 C 125.072 498.549 86.512 501.963 89.206 470.593 L 97.791 436.631 L 131.008 436.631 Z",
    transform: "matrix(-1, 0, 0, -1, 220.079291, 929.750882)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--theme-primary)"
    },
    d: "M 100.565 493.205 L 97.298 442.551 C 91.982 406.519 36.211 401.74 40.108 445.656 L 52.527 493.205 L 100.565 493.205 Z"
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      whiteSpace: "pre",
      fill: "var(--text-sub-headline)",
      fontFamily: "&quot",
      fontSize: "16.8px"
    },
    x: 91.621,
    y: 430.07,
    transform: "matrix(1.070337, -0.25992, -0.05174, 1.055056, -23.924142, 24.221879)"
  }, "RIP"), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "var(--theme-secondary)"
    },
    points: "24.749 493.026 15.038 427.115 18.606 409.723 28.121 423.845 44.622 493.069"
  }), /*#__PURE__*/React.createElement("g", {
    className: "circleWindowNew"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "var(--theme-secondary)",
      stroke: "var(--theme-secondary)",
      strokeWidth: 8
    },
    cx: 266.726,
    cy: 116.632,
    rx: 39.748,
    ry: 39.748
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 0,
      fill: "var(--theme-secondary)"
    },
    points: "230.219 128.89 297.573 96.057 302.093 105.929 231.442 132.014"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 0,
      fill: "var(--theme-secondary)"
    },
    points: "271.992 153.952 250.133 81.88 257.91 78.996 275.872 152.685"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "var(--theme-secondary)"
    },
    points: "166.388 221.839 180.494 272.056 195.637 271.31 188.276 219.338"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "var(--theme-secondary)"
    },
    points: "181.66 276.555 193.28 314.225 203.022 313.888 196.625 277.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "var(--theme-secondary)"
    },
    points: "206.245 313.722 202.006 277.177 218.96 277.739 218.358 313.381"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "var(--theme-secondary)"
    },
    points: "201.543 270.859 196.218 218.232 221.266 215.091 219.124 270.127"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "var(--theme-secondary)"
    },
    points: "264.35 208.236 261.781 267.592 279.624 266.192 287.473 204.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "var(--theme-secondary)"
    },
    points: "261.834 271.766 261.301 313.228 273.654 311.751 278.935 271.783"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "var(--theme-secondary)"
    },
    points: "278.882 311.064 285.894 272.201 312.406 271.823 302.186 307.458"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "var(--theme-secondary)"
    },
    points: "287.352 265.671 300.383 203.029 335.54 197.07 314.556 263.325"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--theme-secondary)"
    },
    d: "M 196.556 442.847 L 188.201 384.326 C 185.155 360.259 222.252 351.815 226.253 383.421 L 223.968 442.523 L 196.556 442.847 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.451,
    y: 378.776,
    width: 36.213,
    height: 3.714,
    style: {
      stroke: "var(--theme-secondary)",
      fill: "var(--theme-secondary)"
    },
    transform: "matrix(0.999436, -0.033589, 0.033589, 0.999436, -32.587228, 17.463866)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.06,
    y: 378.776,
    width: 30.266,
    height: 3.714,
    style: {
      stroke: "var(--theme-secondary)",
      fill: "var(--theme-secondary)"
    },
    transform: "matrix(0.999852, -0.017222, 0.017222, 0.999852, 12.515541, 45.689546)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.131,
    y: 378.776,
    width: 79.036,
    height: 3.714,
    style: {
      stroke: "var(--theme-secondary)",
      fill: "var(--theme-secondary)"
    },
    transform: "matrix(0.050931, 0.998702, -0.998702, 0.050931, 563.601152, -112.631374)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--theme-secondary)"
    },
    d: "M 268.187 362.216 L 259.832 420.737 C 256.786 444.804 293.883 453.248 297.884 421.642 L 295.599 362.54 L 268.187 362.216 Z",
    transform: "matrix(-1, 0, 0, -1, 557.538469, 804.428308)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.451,
    y: 378.776,
    width: 36.213,
    height: 3.714,
    style: {
      stroke: "var(--theme-secondary)",
      fill: "var(--theme-secondary)"
    },
    transform: "matrix(-0.999436, -0.033589, -0.033589, 0.999436, 518.49556, 16.829958)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.06,
    y: 378.776,
    width: 30.266,
    height: 3.714,
    style: {
      stroke: "var(--theme-secondary)",
      fill: "var(--theme-secondary)"
    },
    transform: "matrix(-0.999852, -0.017222, -0.017222, 0.999852, 473.392806, 45.055612)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.131,
    y: 378.776,
    width: 79.036,
    height: 3.714,
    style: {
      stroke: "var(--theme-secondary)",
      fill: "var(--theme-secondary)"
    },
    transform: "matrix(-0.050931, 0.998702, 0.998702, 0.050931, -77.692728, -113.265293)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHHouse);
export default __webpack_public_path__ + "static/media/HHouse.1810ad5a437a232863071b3858db2ece.svg";
export { ForwardRef as ReactComponent };